// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".passwordChangeArea .titleArea {\n  width: 100%;\n}\n.passwordChangeArea .titleArea .title {\n  font-size: 2em;\n  font-weight: 700;\n  text-align: center;\n}\n.passwordChangeArea .titleArea .title .emphasis {\n  color: #C10015;\n}\n.passwordChangeArea .titleArea .subtitle {\n  font-size: 1.05em;\n  font-weight: 500;\n}", ""]);
// Exports
module.exports = exports;
